export enum AudienceTypes {
	One,
	SharePoint,
}
